<h2>Confirma la acción</h2>
<p>
  {{ data.message }}
</p>
<div class="example-button-row">
  <button mat-button id="msgyesno-confirm-btn" (click)="dialogRef.close(true)" mat-dialog-close>Confirma</button>
  <button mat-button (click)="dialogRef.close(false)" mat-dialog-close>Cancelar</button>
</div>
